import { Component, inject, Signal, signal, WritableSignal } from '@angular/core';

import { DialogHandlerComponent } from '../../shared/dialog-handler/dialog-handler.component';

import { FleetService } from '../../services/fleet.service';

import { Fleet } from '../../interfaces/fleet';
import { Transaction } from '../../interfaces/transaction';
import { Ship } from '../../interfaces/ship';
import { ShipClass } from '../../interfaces/ship-class';
import { StarSystem } from '../../interfaces/star-system';

@Component({
  selector: 'ism-ship-assignment',
  standalone: false,
  templateUrl: './ship-assignment.component.html'
})
export class ShipAssignmentComponent extends DialogHandlerComponent {
  NONE = "none";

  fleetService = inject(FleetService);

  title: string = 'Ship Assignment';
  action: string;
  shipTransaction: Transaction;
  ship: Ship;
  shipClass: ShipClass;
  fleet: Fleet;
  starSystemsById: { [key: string]: StarSystem; };
  hexesByStarSystemId: { [key: string]: Set<string>; };
  fleetsBySystemHex: { [key: string]: Fleet[]; };
  syBySystemHex: { [key: string]: boolean; };

  starSystems: WritableSignal<StarSystem[]> = signal([]);
  ssid: WritableSignal<string> = signal("");

  hex: string;
  hexes: string[];

  fleets: Fleet[];
  fleetId: WritableSignal<string> = signal(this.NONE);

  fleetNamePlaceHolder: string;
  fleetName = signal<string>("");

  setHexes (ssid: string) {
    this.hexes = [];
    if (this.action === "activate") {
      for (const hex of this.hexesByStarSystemId[ssid]) {
        if (this.syBySystemHex[ssid + hex]) {
          this.hexes.push(hex);
        }
      }
    }
    else {
      this.hexes = [...this.hexesByStarSystemId[ssid]];
    }
    this.hexes.sort();
    if (this.hexes.indexOf(this.hex) === -1) {
      this.hex = this.hexes[0];
    }
  };

  setFleets (hex: string) {
    this.fleets = this.fleetsBySystemHex[this.ssid() + hex];
    let foundFleet = this.fleets.find(f => (f._id === this.shipTransaction.fleetId));
    this.fleetId.update(old => foundFleet?._id || this.NONE);
    this.fleetNamePlaceHolder = "NewFleet-" + this.starSystemsById[this.ssid()].number + '-' + this.hex;
  };

  constructor () {
    super();

    this.action = this.data['action'];
    this.shipTransaction = this.data.document as Transaction;
    this.ship = this.data['ship'];
    this.shipClass = this.data['shipClass'] as ShipClass;
    this.fleet = this.data['fleet'] as Fleet;
    this.starSystemsById = this.data['starSystemsById'];
    this.hexesByStarSystemId = this.data['hexesByStarSystemId'];
    this.fleetsBySystemHex = this.data['fleetsBySystemHex'];
    this.syBySystemHex = this.data['syBySystemHex'];

    let starSystemIds = Object.keys(this.hexesByStarSystemId) as string[];
    let ss = starSystemIds.map(
      (starSystemId) => this.starSystemsById[starSystemId]
    );
    this.starSystems.update(old => ss);

    setTimeout(() => {

      if (this.fleet) {
        this.ssid.update(old => this.fleet.starSystemId);
        this.setHexes(this.ssid());

        this.hex = this.fleet.locationHex;
        this.setFleets(this.hex);

        this.fleetId.update(old => this.fleet._id);
      }
      else {
        this.ssid.update(old => this.starSystems()[0]._id);
        this.setHexes(this.ssid());

        this.hex = this.hexes[0];
        this.setFleets(this.hex);

        this.fleetId.update(old => this.NONE);
      }
    });
  };

  override save () {
    this.shipTransaction.fleetId = this.fleetId();

    switch (this.action) {
      case "buy":
        this.shipTransaction.amount = this.shipClass.buildCost;
        break;
    }

    this.dialogRef.close({
      documentName: "Transaction",
      document: this.shipTransaction,
      ship: this.ship,

      // only needed IF creating a new fleet
      starSystemId: this.ssid(),
      locationHex: this.hex,
      fleetName: this.fleetName()
    });
  };
};
